<template>
    <div class="main-notice" v-if="showMessage && consultation.family">
        <div class="page__container">
            <div class="mu-notice">
                <img v-if="access === 'patient'" :src="consultation.doctor.avatar.src" class="mu-notice__avatar avatar" :alt="consultation.doctor.avatar.alt">
                <img v-else :src="consultation.family.avatar.src" class="mu-notice__avatar avatar" :alt="consultation.family.avatar.alt">
                <div v-if="access === 'patient'" class="mu-notice__body">
                    <strong v-if="pending" class="mu-notice__msg r-strong" v-html="consultation.doctor.name + ` ожидает Вас на онлайн консультацию!`"></strong>
                    <strong v-else-if="started" class="mu-notice__msg r-strong" v-html="consultation.doctor.name + ` начал(а) онлайн консультацию!`"></strong>
                    <div class="cookie-notice__info" v-if="pending">
                        <p>
                            Ваша онлайн консультация с {{ consultation.doctor.name }}
                            начнётся через
                            <span v-if="~~(timeDiff / 60) >= 1" class="mu-notice__time" v-html="~~(timeDiff / 60) + ` ` + getTimeName(~~(timeDiff / 60))"></span>
                            <span v-else class="mu-notice__time" v-html="`несколько секунд.`"></span>
                        </p>
                    </div>
                    <div class="cookie-notice__info" v-else-if="started">
                        <p>
                            Похоже Вы забыли о Вашей онлайн записи к
                            {{ consultation.doctor.name }}. Пожалуйста, перейдите на страницу с консультацией
                        </p>
                    </div>
                </div>
                <div v-else class="mu-notice__body">
                    <strong v-if="pending" class="mu-notice__msg r-strong" v-html="`Пациент ожидает Вас!`"></strong>
                    <strong v-else-if="started" class="mu-notice__msg r-strong" v-html="`Консультация началась!`"></strong>
                    <div class="cookie-notice__info" v-if="pending">
                        <p>
                            Пожалуйста, не забудьте о онлайн консультации, которая начнётся через
                            <span v-if="~~(timeDiff / 60) >= 1" class="mu-notice__time" v-html="~~(timeDiff / 60) + ` ` + getTimeName(~~(timeDiff / 60))"></span>
                            <span v-else class="mu-notice__time" v-html="`несколько секунд.`"></span>
                        </p>
                    </div>
                    <div class="cookie-notice__info" v-else-if="started">
                        <p>
                            Похоже Вы забыли о Вашей онлайн записи. Пожалуйста, перейдите на страницу с консультацией.
                        </p>
                    </div>
                </div>
                <div class="mu-notice__actions">
                    <a :href="consultation.link" class="r-link button">Перейти к консультации</a>
                    <button v-if="pending" @click="closeMessage" class="mu-notice__action mu-notice__sec-action r-button button-pseudo" type="button">Хорошо, перейду позже</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import api from "../../../admin/api/api";

    import dayjs from "dayjs";
    import utc from 'dayjs/plugin/utc';

    dayjs.extend(utc);

    export default {
        name: "ConsultationWaiting",
        props: {
            access: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                showMessage: false,
                interval: null,
                consultationInterval: null,
                pending: false,
                started: false,
                timeNow: {},
                timer: 3000,
                timeDiff: 0,
                timeZone: null,
                consultation: []
            }
        },
        methods: {
            getConsultation() {
                api.get('/api/consultations/last/open')
                    .then((response) => {
                        this.consultation = response.data.consultation;
                        this.timezone = response.data.consultation.timezone;
                        this.timeNow = dayjs.createFromTimezone(response.data.consultation.timeNow, this.timezone);
                    })
                    .catch((error) => {

                    });
            },
            closeMessage() {
                this.showMessage = false;

                localStorage.setItem('consultation-notice-hide', true);
            },
            checkDisabled() {
                if (this.consultation && this.consultation.start_at) {
                    this.timeNow = this.timeNow.add(this.timer, 'milliseconds');

                    this.timeDiff = dayjs.createFromTimezone(this.consultation.start_at, this.timezone).diff(this.timeNow, 'second');

                    if (this.timeDiff <= 900 && this.timeDiff > 0 && localStorage.getItem('consultation-notice-hide') !== 'true') {
                        this.showMessage = true;
                        this.pending = true;
                    }

                    if (this.timeDiff <= 0) {
                        localStorage.setItem('consultation-notice-hide', false);

                        this.showMessage = true;
                        this.pending = false;
                        this.started = true;
                    }
                    if (this.timeDiff > 900) {
                        this.showMessage = false;
                    }
                }
            },
            getTimeName(time) {
                if (time == 1) {
                    return 'минуту';
                }

                if (time < 5) {
                    return 'минуты'
                }

                return 'минут';
            }
        },
        mounted() {
            this.getConsultation();

            this.checkDisabled();

            this.consultationInterval = setInterval(() => {
                this.getConsultation();
            }, 60000);

            this.interval = setInterval(() => {
                this.checkDisabled();
            }, this.timer);
        }
    }
</script>
